import { ApiManagerService } from '@ildes/services/api-manager.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LogService {

  enabled = false;
  constructor(
    private api: ApiManagerService
  ) { }

  public info(data) {
    if (this.enabled) {
      this.api.log(data).subscribe( () => {

      }, () => {

      })
    }
  }

}
